import Tools from '@/components/tools/Tools.js'

export default {
  name: 'tablesalesaccreditedmonth',
  props: [
    'columns',
    'dataProposta',
    'dataEnterprise',
    'verificarMes',
    'i',
    'showHeader',
    'dataSales'
  ],

  data () {
    return {
      rows: [],
      totalSaleValue: 0,
      title: 'N/A',
      totalBrokers: 0
    }
  },
  mounted () {
    var accredteds = ''
    this.title = this.dataSales[0].nomeEmpreendimento
    this.dataSales.forEach((sale) => {
      this.totalSaleValue += sale.valorVenda
      if (!accredteds.includes(sale.nomeCredenciada)) {
        this.totalBrokers++
        accredteds += ` ${sale.nomeCredenciada}`
      }
      this.rows.push(
        {
          nomeCredenciada: sale.nomeCredenciada,
          valorTotal: sale.valorVenda,
          data: sale.data
        }
      )
    })
  },

  methods: {
    calculaSalesEnterprise (proposta) {
      let total = 0
      proposta.forEach(p => {
        if (new Date(p.dataVenda).getMonth() === this.i) {
          total = total + p.valorTotal
        }
      })
      proposta.forEach(p => {
        total = total + p.valorTotal
      })
      return total
    },
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    calcularProposta (id) {
      let total = 0
      let proposta = this.dataEnterprise.proposta.filter(
        Element => Element.contaId === id
      )
      proposta.forEach(Element => {
        total = total + Element.valorTotal
      })
      return total
    },
    calcularTotalVenda (id) {
      let total = 0
      let proposta = this.dataEnterprise.proposta.filter(
        Element => Element.contaId === id
      )
      proposta.forEach(Element => {
        total++
      })
      return total
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/salesbyaccredited/components/tablesalesaccreditedmonth/tablesalesaccreditedmonth.js